export default __webpack_public_path__ + "static/media/cafe.f550386d.jpg";